import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { Button } from '@factorialco/factorial-one-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import UpsellButtons from 'modules/product_updates/components/UpsellButtons'

import SubscriptionButtons from './_SubscriptionButtons'

type Props = {
  chargebeeModuleName: string | null | undefined
  productUpdateSlug: string
  isAlreadyReleased: boolean
  productUpdateId: string
  featureIdentifier: string
  version?: 'factorial-one'
  source?: string
  navigationSlug?: string
}

const Buttons = ({
  chargebeeModuleName,
  productUpdateSlug,
  isAlreadyReleased,
  productUpdateId,
  featureIdentifier,
  version,
  source,
  navigationSlug,
}: Props) => {
  const canSeeUpsellButton = !!chargebeeModuleName && isAlreadyReleased
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  return (
    <Box flexDirection="row" gap="s8">
      {canSeeUpsellButton && (
        <UpsellButtons
          chargebeeModuleName={chargebeeModuleName}
          productUpdateSlug={productUpdateSlug}
          featureIdentifier={featureIdentifier}
          version={version}
          source={source}
        />
      )}
      {!isAlreadyReleased && (
        <SubscriptionButtons
          productUpdateId={productUpdateId}
          productUpdateSlug={productUpdateSlug}
          version={version}
          source={source}
        />
      )}
      <Button
        label={
          navigationSlug ? i18n.t('product_updates.view_more') : i18n.t('product_updates.read_more')
        }
        variant="outline"
        onClick={() => {
          if (navigationSlug) {
            navigate(navigation.discover.fullPath() + `/${navigationSlug}`)
          } else {
            navigate(navigation.discover.productUpdates.item.fullPath({ slug: productUpdateSlug }))
          }
        }}
      />
    </Box>
  )
}

export default Buttons
